module.exports = __webpack_public_path__ + "img/bg_year_proportion.99a96085.png";